<template>
  <section class="h-full mx-4">
    <BaseTable
      v-if="traderSites"
      :totalRecords="200"
      :headers="traderSitesHeaders"
      :list="traderSites"
      table-id="table-1"
      @refresh-data="refreshData"
      @apply-filters="onApplyFilters"
      @reset-filters="onResetFilters">
      <template #actions>
        <div class="flex items-center justify-center gap-1">
          <button
            type="button"
            class="rounded-full p-1.5 text-theme-500 shadow-sm hover:bg-theme-50">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="size-4">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
            </svg>
          </button>
          <button type="button" class="rounded-full p-1.5 text-red-400 shadow-sm hover:bg-red-50">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="size-4">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
            </svg>
          </button>
        </div>
      </template>
      <template #filters>
        <div class="grid grid-cols-1 gap-10 px-6 py-10 mx-auto max-w-7xl md:px-8 md:grid-cols-4">
          <!-- Column 1: Engagement -->
          <div class="space-y-4">
            <h3 class="text-sm font-light leading-6 text-gray-400 uppercase">By Type</h3>
            <div class="flex items-center space-x-3">
              <input
                id="engagement-comments"
                type="checkbox"
                name="engagement-comments"
                class="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-600" />
              <label for="engagement-comments" class="text-sm font-normal text-gray-600"
                >New comments</label
              >
            </div>
            <div class="flex items-center space-x-3">
              <input
                id="engagement-candidates"
                type="checkbox"
                name="engagement-candidates"
                class="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-600" />
              <label for="engagement-candidates" class="text-sm font-normal text-gray-600"
                >New candidates</label
              >
            </div>
            <div class="flex items-center space-x-3">
              <input
                id="engagement-offers"
                type="checkbox"
                name="engagement-offers"
                class="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-600" />
              <label for="engagement-offers" class="text-sm font-normal text-gray-600"
                >Offers</label
              >
            </div>
          </div>

          <!-- Column 2: Resources -->
          <div class="space-y-4">
            <h3 class="text-sm font-light leading-6 text-gray-400 uppercase">By status</h3>
            <div class="flex items-center space-x-3">
              <input
                id="resources-updates"
                type="checkbox"
                name="resources-updates"
                class="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-600" />
              <label for="resources-updates" class="text-sm font-normal text-gray-600"
                >New updates</label
              >
            </div>
            <div class="flex items-center space-x-3">
              <input
                id="resources-feedback"
                type="checkbox"
                name="resources-feedback"
                class="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-600" />
              <label for="resources-feedback" class="text-sm font-normal text-gray-600"
                >User feedback</label
              >
            </div>
            <div class="flex items-center space-x-3">
              <input
                id="resources-signup"
                type="checkbox"
                name="resources-signup"
                class="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-600" />
              <label for="resources-signup" class="text-sm font-normal text-gray-600"
                >New signup</label
              >
            </div>
          </div>

          <!-- Column 3 -->
          <div class="space-y-4">
            <h3 class="text-sm font-light leading-6 text-gray-400 uppercase">Effective from</h3>
            <div class="flex items-center space-x-3">
              <input
                id="resources-updates"
                type="checkbox"
                name="resources-updates"
                class="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-600" />
              <label for="resources-updates" class="text-sm font-normal text-gray-600"
                >New updates</label
              >
            </div>
            <div class="flex items-center space-x-3">
              <input
                id="resources-feedback"
                type="checkbox"
                name="resources-feedback"
                class="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-600" />
              <label for="resources-feedback" class="text-sm font-normal text-gray-600"
                >User feedback</label
              >
            </div>
            <div class="flex items-center space-x-3">
              <input
                id="resources-signups"
                type="checkbox"
                name="resources-signups"
                class="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-600" />
              <label for="resources-signups" class="text-sm font-normal text-gray-600"
                >New signups</label
              >
            </div>
          </div>

          <!-- Column 4 -->
          <div class="space-y-4">
            <h3 class="text-sm font-light leading-6 text-gray-400 uppercase">Effective to</h3>
            <div class="flex items-center space-x-3">
              <input
                id="resources-updates"
                type="checkbox"
                name="resources-updates"
                class="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-600" />
              <label for="resources-updates" class="text-sm font-normal text-gray-600"
                >New updates</label
              >
            </div>
            <div class="flex items-center space-x-3">
              <input
                id="resources-feedback"
                type="checkbox"
                name="resources-feedback"
                class="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-600" />
              <label for="resources-feedback" class="text-sm font-normal text-gray-600"
                >User feedback</label
              >
            </div>
            <div class="flex items-center space-x-3">
              <input
                id="resources-signups"
                type="checkbox"
                name="resources-signups"
                class="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-600" />
              <label for="resources-signups" class="text-sm font-normal text-gray-600"
                >New signups</label
              >
            </div>
          </div>
        </div>
      </template>
    </BaseTable>
  </section>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { getTraderSites } from '@/services/api/auth';
import BaseTable from '@/components/common/BaseTable.vue';
import { useI18n } from 'vue-i18n';

const traderSites = ref<any[]>([]);
const { t: $t } = useI18n({ useScope: 'global' });
const traderSitesHeaders = [
  { value: 'boid', text: $t('baseObject.boid'), type: 'text', active: true },
  { value: 'code', text: $t('baseObject.code'), type: 'text', active: true },
  { value: 'name', text: $t('baseObject.name'), type: 'text', active: true },
  { value: 'city', text: $t('city'), type: 'text', active: true },
  { value: 'trader.doy', text: $t('trader.doy'), type: 'text', active: true },
  { value: 'trader.job', text: $t('trader.job'), type: 'text', active: true },
  { value: 'isFromManager', text: $t('baseObject.isFromManager'), type: 'check', active: true },
  { value: 'isHQ', text: $t('HQ'), type: 'check', active: true },
  { value: 'isBranch', text: $t('branch'), type: 'check', active: true },
  { value: 'isActive', text: $t('baseObject.isActive'), type: 'status', active: true },
  { value: 'actions', text: $t('baseObject.actions'), active: true },
];

onMounted(async () => {
  traderSites.value = await getTraderSites('', 0, 50, '');
});

async function refreshData(item: any) {
  getSites(item);
}

async function getSites(item: any) {
  traderSites.value = await getTraderSites(
    item.query,
    (item.page - 1) * item.itemsPerPage,
    item.itemsPerPage,
    item.column,
    item.order
  );
}
function onApplyFilters() {}
function onResetFilters() {}
</script>
